import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App";
import SocketPlugin from "./plugin/socket";
import Store from "./store";
import * as Internationalization from "./internationalization";
import "./polyfills";
console.log("git commit: " + process.env.GIT_COMMIT);
Vue.use(SocketPlugin, {
    store: Store,
    onError: function (error) {
        Store.dispatch("setMinorError", "WEBSOCKET");
        console.error(error);
    },
});
Vue.use(VueI18n);
Vue.config.productionTip = false;
var i18n = new VueI18n({
    locale: Internationalization.getLanguage(),
});
/* eslint-disable no-new */
/* tslint:disable:no-unused-expression */
new Vue({
    el: "#app",
    template: "<App/>",
    components: { App: App },
    store: Store,
    i18n: i18n,
});
if (window.Raven) {
    window.Raven.config("https://541a1dde7b5147c989e8d153a89a350f@sentry.io/197022").install();
}



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 342
// module chunks = 1